module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Bartek_Marta.53f78085.jpg";